module.exports = __webpack_public_path__ + "static/media/profile.a4e1d7f6.jpg";